import {
  GET_ALL_STATIONS_FAILURE,
  GET_ALL_STATIONS_SUCCESS,
  FETCH_ALL_STATIONS,
  GET_MODULES_SUCCESS,
  GET_MODULES_FAILURE,
  GET_TASKS_FAILURE,
  GET_TASKS_SUCCESS,
  FETCH_TASKS,
  GET_TASKS_DESCRIPTION_FAILURE,
  GET_TASKS_DESCRIPTION_SUCCESS,
  FETCH_TASKS_DESCRIPTION,
  FETCH_MODULES,
  ADD_TASK_DES_SUCCESS,
  ADD_TASK_DES_FAILURE,
  ADD_TASK_DES,
  UPDATE_TASK_DES,
  UPDATE_TASK_DES_FAILURE,
  UPDATE_TASK_DES_SUCCESS,
  GET_MODULES_AND_STATION_RATING_FAILURE,
  GET_MODULES_AND_STATION_RATING_SUCCESS,
  FETCH_MODULES_AND_STATION_RATING,
  LOG_OUT,
  FETCH_ALL_CHECK_UPDATES,
  GET_ALL_CHECK_UPDATES_SUCCESS,
  GET_ALL_CHECK_UPDATES_FAILURE,
} from "../constant";

const initState = {
  stations: {
    success: false,
    error: "",
    isFetched: false,
    stations: [],
    dates: [],
  },
  modules: {
    success: false,
    error: "",
    modules: [],
    isFetched: false,
    message: "",
  },
  tasks: {
    success: false,
    tasks: [],
    error: "",
    isFetched: false,
  },
  tasksDes: {
    success: false,
    error: "",
    tasksDes: [],
    isFetched: false,
  },
  addTaskDes: {
    success: false,
    error: "",
    message: "",
    isPost: false,
  },
  updateTaskDes: {
    success: false,
    error: "",
    message: "",
    isUpdate: false,
  },
  modAndStationRating: {
    success: false,
    error: "",
    modRating: [],
    stationRating: 0,
    isFetched: false,
  },
  checkUpdates: {
    success: false,
    error: "",
    isFetched: false,
    dates: [],
  },
};

export default function Stations(state = initState, action) {
  switch (action.type) {
    case FETCH_ALL_STATIONS:
      return {
        ...state,
        stations: {
          success: false,
          error: "",
          isFetched: false,
          stations: [],
          dates: [],
        },
      };
    case GET_ALL_STATIONS_SUCCESS:
      return {
        ...state,
        stations: {
          success: action.payload.success,
          error: "",
          isFetched: true,
          stations: action.payload.stations,
          dates: action.payload.dates,
        },
      };
    case GET_ALL_STATIONS_FAILURE:
      return {
        ...state,
        stations: {
          success: false,
          error: action.payload.error,
          isFetched: true,
          stations: [],
          dates: [],
        },
      };

    case FETCH_MODULES:
      return {
        ...state,
        modules: {
          success: false,
          error: "",
          isFetched: false,
          modules: [],
          message: "",
        },
      };
    case GET_MODULES_SUCCESS:
      return {
        ...state,
        modules: {
          success: action.payload.success,
          error: "",
          isFetched: true,
          modules: action.payload.modules,
          message: action.payload.message,
        },
      };
    case GET_MODULES_FAILURE:
      return {
        ...state,
        modules: {
          success: false,
          error: action.payload.error,
          isFetched: true,
          modules: [],
          message: "",
        },
      };

    case FETCH_TASKS:
      return {
        ...state,
        tasks: {
          success: false,
          tasks: [],
          error: "",
          isFetched: false,
        },
      };
    case GET_TASKS_SUCCESS:
      return {
        ...state,
        tasks: {
          success: action.payload.success,
          error: "",
          isFetched: true,
          tasks: action.payload.tasks,
        },
      };
    case GET_TASKS_FAILURE:
      return {
        ...state,
        tasks: {
          success: false,
          error: action.payload.error,
          isFetched: true,
          tasks: [],
        },
      };

    case FETCH_TASKS_DESCRIPTION:
      return {
        ...state,
        tasksDes: {
          success: false,
          error: "",
          tasksDes: [],
          isFetched: false,
        },
      };
    case GET_TASKS_DESCRIPTION_SUCCESS:
      return {
        ...state,
        tasksDes: {
          success: action.payload.success,
          error: "",
          isFetched: true,
          tasksDes: action.payload.tasksDes,
        },
      };
    case GET_TASKS_DESCRIPTION_FAILURE:
      return {
        ...state,
        tasksDes: {
          success: false,
          error: action.payload.error,
          isFetched: true,
          tasksDes: [],
        },
      };

    case ADD_TASK_DES:
      return {
        ...state,
        addTaskDes: {
          success: "",
          error: "",
          message: "",
          isPost: false,
        },
      };
    case ADD_TASK_DES_SUCCESS:
      return {
        ...state,
        addTaskDes: {
          success: action.payload.success,
          error: "",
          message: action.payload.message,
          isPost: true,
        },
      };
    case ADD_TASK_DES_FAILURE:
      return {
        ...state,
        addTaskDes: {
          success: false,
          error: action.payload.error,
          message: "",
          isPost: true,
        },
      };

    case UPDATE_TASK_DES:
      return {
        ...state,
        updateTaskDes: {
          success: "",
          error: "",
          message: "",
          isUpdate: false,
        },
      };
    case UPDATE_TASK_DES_SUCCESS:
      return {
        ...state,
        updateTaskDes: {
          success: action.payload.success,
          error: "",
          message: action.payload.message,
          isUpdate: true,
        },
      };
    case UPDATE_TASK_DES_FAILURE:
      return {
        ...state,
        updateTaskDes: {
          success: false,
          error: action.payload.error,
          message: "",
          isUpdate: true,
        },
      };

    case FETCH_MODULES_AND_STATION_RATING:
      return {
        ...state,
        modAndStationRating: {
          success: false,
          error: "",
          modRating: [],
          stationRating: 0,
          isFetched: false,
        },
      };
    case GET_MODULES_AND_STATION_RATING_SUCCESS:
      return {
        ...state,
        modAndStationRating: {
          success: action.payload.success,
          error: "",
          modRating: action.payload.modRating,
          stationRating: action.payload.stationRating,
          isFetched: true,
        },
      };
    case GET_MODULES_AND_STATION_RATING_FAILURE:
      return {
        ...state,
        stations: {
          success: false,
          error: action.payload.error,
          isFetched: true,
          modRating: [],
          stationRating: 0,
        },
      };
    case FETCH_ALL_CHECK_UPDATES: {
      return {
        ...state,
        checkUpdates: {
          success: false,
          error: "",
          isFetched: false,
          dates: [],
        },
      };
    }
    case GET_ALL_CHECK_UPDATES_SUCCESS: {
      return {
        ...state,
        checkUpdates: {
          success: action.payload.success,
          error: "",
          isFetched: true,
          dates: action.payload.dates,
        },
      };
    }
    case GET_ALL_CHECK_UPDATES_FAILURE: {
      return {
        ...state,
        checkUpdates: {
          success: false,
          error: action.payload.error,
          isFetched: true,
          dates: [],
        },
      };
    }
    case LOG_OUT:
      return {
        initState,
      };
    default:
      return state;
  }
}
